// extracted by mini-css-extract-plugin
export default {"slider":"CardsNumber_slider__D8E5g","value":"CardsNumber_value__4UlLa"};